module.exports = __webpack_public_path__ + "static/media/135_ExteriorEntry.b7b05653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_ExteriorEntry.jpg
// module id = 528
// module chunks = 0